export const alphabeticalSort = (a: string, b: string): number =>
  a.localeCompare(b);
